import {
  FileText,
  Search,
  DollarSign,
  Building2,
  Lightbulb,
  MapPin,
} from "lucide-react";


import {
  Foundations,
  Grassroots,
  NonProfit,
  Corporation,
  SnapReact,
  FistReact,
  ClappingReact,
  HeartReact,
} from "../Assets/SvgIcons";

const COGNITO = {
  CONFIRM_SIGNUP_SUCCESS_RESPONSE: "SUCCESS",
};

const ORGANIZATION_CARD_NAME_LENGTH = 20;

export const addNewOrganizationsCardsData = [
  {
    illustration: Grassroots,
    title: "Grassroots",
    description:
      "A group of BIPOC people most impacted by a problem working to ignite social change",
  },
  {
    illustration: NonProfit,
    title: "Non-profit",
    description:
      "A charitable entity organized and operated to ignite social change",
  },
  {
    illustration: Foundations,
    title: "Foundation",
    description: "An organization that provides money to ignite social change",
  },
  {
    illustration: Corporation,
    title: "Corporation",
    description:
      "A company that provides money or resources to ignite social change",
  },
];

const INTERACTION_ICONS = {
  SNAPS: SnapReact,
  HEART: HeartReact,
  FIST: FistReact,
  HIGHFIVE: ClappingReact,
};

const TARGET_SYMBOLS = {
  DOLLARS: "$",
  NUMBERS: "",
  PERCENTAGES: "%",
};

export {
  COGNITO,
  ORGANIZATION_CARD_NAME_LENGTH,
  INTERACTION_ICONS,
  TARGET_SYMBOLS,
};

export const NUMBER_OF_LOGINS_BEFORE_HIDING_INTRO = 5;

export const VALID_PHOTO_EXTENSIONS = ".jpg, .jpeg, .png";

export enum POLICY_TYPES {
  ACCEPTABLE_USE = "acceptable-use-policy",
  PRIVACY = "privacy-policy",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
  COOKIE = "cookie-policy",
}

export const categories = [
  {
    title: "Government Grants",
    description: "Federal and state funding opportunities",
    icon: Building2,
    items: ["Explore Government Grants"],
    color: "from-purple-500/10 to-purple-600/10 border-purple-200",
    link: "https://www.grants.gov/search-grants",
  },
  {
    title: "Private Sector Grants",
    description: "Corporate and foundation funding sources",
    icon: DollarSign,
    items: ["Explore Private Grants"],
    color: "from-orange-500/10 to-orange-600/10 border-orange-200",
    link: "https://www.instrumentl.com/browse-grants ",
  },
  {
    title: "Our Data Gallery",
    description: "Additional resources and case studies",
    icon: Lightbulb,
    items: ["Explore Data Gallery"],
    color: "from-pink-500/10 to-pink-600/10 border-pink-200",
    link: "https://wemeasure.org/data-gallery/",
  },
  {
    title: "Spark Map",
    description: "Interactive network of innovation hubs and collaborators",
    icon: MapPin,
    items: ["Explore Interactive Map"],
    color: "from-cyan-500/10 to-cyan-600/10 border-cyan-200",
    link: "/sparks-map",
  },
  {
    title: "Black Papers",
    description: "In-depth research documents and industry insights",
    icon: FileText,
    items: ["Coming Soon..."],
    color: "from-blue-500/10 to-blue-600/10 border-blue-200",
    link: "#",
  },
  {
    title: "Research",
    description: "Latest studies and academic research findings",
    icon: Search,
    items: ["Coming Soon..."],
    color: "from-green-500/10 to-green-600/10 border-green-200",
    link: "#",
  },
];




